module.exports = __webpack_public_path__ + "img/SmallBusbuttons.05c3e147.png";